<template>
  <v-card class="pa-3 mb-3">

    <v-radio-group v-model="group.goster" row>
      <v-radio label="Göster" value="goster"></v-radio>
      <v-radio label="Gizle" value="gizle"></v-radio>
    </v-radio-group>
    <v-row align="center">
      <v-col cols="3">
        <v-select v-model="group.logic" :items="compares" item-text="name" item-value="id" label="Logic" dense />
      </v-col>
      <v-col cols="9" class="text-right">
        <v-btn small color="primary" @click="addCondition">Koşul Ekle</v-btn>
        <v-btn small color="secondary" @click="addGroup">Grup Ekle</v-btn>
      </v-col>
    </v-row>

    <v-list dense>
      <v-list-item v-for="(cond, i) in group.conditions" :key="i">
        <!-- Eğer alt grupsa recursive render -->
        <ConditionBuilder v-if="cond.conditions" v-model="group.conditions[i]" :fields="fields" />
        <!-- Yoksa tek koşul -->
        <div v-else class="d-flex align-center">
          <v-select class="mr-2 select-width"
 v-model="cond.field" :items="fields" label="Alan" item-text="name" item-value="id" dense width="250"
            />
          <v-select v-model="cond.operator" :items="operators" item-text="name" item-value="id" label="Operatör" dense
            class="mr-2" />
          <v-text-field v-model="cond.value" label="Değer" dense class="mr-2" />
          <v-btn icon small @click="removeCondition(i)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "ConditionBuilder",
  props: {
    value: { type: Object, required: true },
    fields: { type: Array, required: true }
  },
  data() {
    return {


      compares: [
        { id: "AND", name: "Ve" },
        { id: "OR", name: "Veya" }
      ],
      operators: [
        { id: "equals", name: "Eşit" }
        , { id: "notEquals", name: "Eşit Değil" }
        , { id: "contains", name: "İçerir" }
        , { id: "greater", name: "Büyük" }
        , { id: "greaterOrEqual", name: "Büyük veya Eşit" }
        , { id: "less", name: "Küçük" }
        , { id: "lessOrEqual", name: "Küçük veya Eşit" }
      ],
      operators1: [
        "equals",
        "notEquals",
        "contains",
        "greater",
        "greaterOrEqual",
        "less",
        "lessOrEqual"
      ]
    };
  },
  computed: {
    group: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    addCondition() {
       let tempItem= this.fields.length>0 ? this.fields[0].id : null;
      this.group.conditions.push({
        field: tempItem,
        operator: "equals",
        value: ""
      });
    },
    addGroup() {
      this.group.conditions.push({
        logic: "AND",
        conditions: []
      });
    },
    removeCondition(index) {
      this.group.conditions.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.select-width {
  width: 150px;
}
</style>
